/* eslint-disable */
import {propsDecorator} from '@/js/common/Domain/Service/mixins/decorators';
import SimilarTour from '@/js/common/components/similarTour/SimilarTour';
import FreeCancellationSignDesktop from '@/js/desktop/components/freeCancellationSign';
import TooltipPopoverHtml from '@/js/common/components/tooltip/htmlTooltip/HtmlTooltip';
import '@/css/common/components/warranted-icon.scss';

import template from './template.html';

@propsDecorator({
    el: "<div class='similarToursSelect__tour'></div>",
    template,
    events: {
        click: 'goToTour',
    },
})

export default class SimilarTourDesktop extends SimilarTour {
    initFreeCancellation() {
        if (this.model.get('tour').get('freeCancellation')) {
            new FreeCancellationSignDesktop({
                el: $('.freeCancellation__sign', this.$el),
            });
        }
    }

    render() {
        super.render();

        if (this.model.get('tour').get('hotelAvailable')) {
            this.warrantyTooltip = new TooltipPopoverHtml({
                el: $('.js-warranted-icon-similar', this.$el),
            });
        }
    }
}